/**
 * WEBE-26603 — experiment exposure event. Reuses galleria's existing Amplitude `logEvent`.
 * `logEvent` does NOT check consent (`_document` always installs the `window.amplitude` loader stub, and
 * the SDK stays live after withdrawal), so callers must: AbExposure only calls this with A/B consent.
 * The variant comes from the visitor's `ab_bucket` cookie (assigned by Fastly, forwarded as `X-AB-Bucket`);
 * this only records that a variant was shown.
 */
import { logEvent } from '@/utils/analytics';

type Exposure = { experimentKey: string; variant: string };

export const trackExposure = ({ experimentKey: flagKey, variant }: Exposure) => {
  logEvent('$exposure', { flag_key: flagKey, variant });
};
